import React, { useState } from 'react';
import ParticlesComponent from './ParticlesBackground';
import ChatBox from './ChatBox';
import Modal from './Modal';
import TypeHeadline from './TypeHeadline';
import { FaLinkedin, FaGithub, FaFacebook, FaEnvelope, FaCalendarAlt, FaRobot, FaTh } from 'react-icons/fa';
import { FaMapMarkerAlt } from 'react-icons/fa';


import './App.css';


function App() {
  const [app_state, setAppState] = useState("inactive");  // inactive, listening, active
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Robot icon cycles the chat: inactive -> listening -> active -> listening ...
  const toggleAIChat = () => {
    if (app_state === "inactive") {
      setAppState("listening");
    } else if (app_state === "listening") {
      setAppState("active");
    } else {
      setAppState("listening");
    }
  };

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const updateMessageFromChildComponent = (newMessage: string) => {
    if (newMessage === "processing") {
      setAppState("active");
    }
  };

  return (
    <div className="App">
      <ParticlesComponent id="tsparticles" particles_state={app_state}/>
      <header className="App-header">
        <div className="console-card">
          <div className="status-chips">
            {/* keep the app count in sync with the apps modal tile count */}
            <span className="chip"><span className="chip-dot" aria-hidden="true" />13 live apps</span>
            <span className="chip">Seattle, WA</span>
            <span className="chip chip-ok">status: available_for_work</span>
          </div>

          <TypeHeadline text="Blue Sky Engineering" className="console-title" />
          <p className="console-subtitle">AI, Data Science, &amp; Machine Learning Services</p>

          <p className="console-copy">
            Whether you're looking to leverage AI for business growth, optimize
            operations with data science, or implement cutting-edge machine
            learning models, I'm here to help you achieve your goals.
          </p>
          <p className="console-copy">
            Explore the <button type="button" className="inline-link apps-link" onClick={toggleModal}>sample applications</button>,
            {' '}or <button type="button" className="inline-link ai-link" onClick={toggleAIChat}>talk to my AI persona</button> —
            {' '}or go straight to the console below.
          </p>

          <a className="cta-command" href="https://calendly.com/applybluesky/30min"
             target="_blank" rel="noopener noreferrer">
            <span className="cta-prompt" aria-hidden="true">&gt;</span>
            <span>book_a_call</span>
            <span className="cta-hint">— free 30 min intro</span>
          </a>

          {/* ChatBox renders empty transcript/response chrome when idle —
              mount it only once the user has engaged the AI persona. */}
          {app_state !== 'inactive' &&
            <ChatBox app_state={app_state} onUpdateMessage={updateMessageFromChildComponent} />}
        </div>

        <nav className="tile-grid" aria-label="quick actions">
          <div className="social-icon-wrapper">
            <a href="mailto:applybluesky@gmail.com" className="social-icon" aria-label="Email">
                <FaEnvelope size={34} />
                <span className="icon-label">Email</span>
              </a>
          </div>
          <div className="social-icon-wrapper">
            <a href="https://calendly.com/applybluesky/30min" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Book a Call">
                <FaCalendarAlt size={34} />
                <span className="icon-label">Book a Call</span>
              </a>
          </div>
          <div className="social-icon-wrapper">
            <a href="https://linkedin.com/in/rniice" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="LinkedIn">
                <FaLinkedin size={34} />
                <span className="icon-label">LinkedIn</span>
              </a>
          </div>
          <div className="social-icon-wrapper">
            <a href="https://github.com/mcrockett86" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="GitHub">
                <FaGithub size={34} />
                <span className="icon-label">GitHub</span>
              </a>
          </div>
          <div className="social-icon-wrapper tile-ai">
            <a role="button" href="#foo" onClick={(e) => { e.preventDefault(); toggleAIChat(); }} className="social-icon" aria-label="Chat with AI">
                <FaRobot size={34} />
                <span className="icon-label">Chat with AI</span>
              </a>
          </div>
          <div className="social-icon-wrapper">
            <a role="button" href="#apps" onClick={(e) => { e.preventDefault(); toggleModal(); }} className="social-icon" aria-label="Apps">
                <FaTh size={34} />
                <span className="icon-label">Apps</span>
              </a>
          </div>
          <div className="social-icon-wrapper">
            <a href="https://www.google.com/maps/place/47%C2%B037'17.0%22N+122%C2%B020'18.5%22W/@47.6241954,-122.357612,12940m/data=!3m1!1e3!4m4!3m3!8m2!3d47.6213889!4d-122.3384722?entry=ttu&g_ep=EgoyMDI1MDgzMC4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Location">
                <FaMapMarkerAlt size={34} />
                <span className="icon-label">Location</span>
              </a>
          </div>
          <div className="social-icon-wrapper">
            <a href="https://www.facebook.com/croketm/" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Facebook">
                <FaFacebook size={34} />
                <span className="icon-label">Facebook</span>
              </a>
          </div>
        </nav>
      </header>
      {isModalOpen && <Modal onClose={toggleModal} />}
    </div>

  );
}

export default App;
